import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import {
  InquiryState,
  InquiryParams,
  InquiryUpdateParams,
  InquiryApiResponse,
} from "./InquiryType";
import { RootState } from "../../redux/store";
import { GetTime } from "../../utils/timeget";

export const fetchAsyncInquiry: any = createAsyncThunk<
  InquiryApiResponse,
  InquiryParams
>("Inquiry/get", async () => {
  const response = await axiosSettings.get("api-admin/inquiry");
  return response.data;
});

//コメントをアップデートする仕組みを作る。引数
export const fetchAsyncUpdateComment: any = createAsyncThunk<
  InquiryApiResponse,
  InquiryParams
>("inquiryUpdate/put", async (updateData) => {
  try {
    const response = await axiosSettings.put(
      `api-admin/inquiry/comment/${updateData.id}`,
      updateData
    );
    return response.data;
  } catch (error) {
    console.log("更新中にエラーが発生しました", error, updateData);
  }
});

//コンプリートをアップデートする仕組みを作る。引数
export const fetchAsyncUpdateCompleted: any = createAsyncThunk<
  InquiryApiResponse,
  InquiryParams
>("inquiryUpdate/put", async (updateData) => {
  try {
    const response = await axiosSettings.put(
      `api-admin/inquiry/completed/${updateData.id}`,
      updateData
    );
    return response.data;
  } catch (error) {
    console.log("更新中にエラーが発生しました", error, updateData);
  }
});

const initialState: InquiryState = {
  inquiryStatus: [],
  inquiry: { completed: null, incompleted: null },
  updatedTime: "",
  loading: false,
  error: "",
};

const InquirySlice = createSlice({
  name: "Inquiry",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAsyncInquiry.fulfilled, (state, action) => {
        if (action.payload.status === "Success") {
          state.inquiry = action.payload.data.result;
          state.updatedTime = GetTime();
        } else {
          state.error = action.payload.data;
        }
        state.loading = false;
      })
      .addCase(fetchAsyncInquiry.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAsyncInquiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const InquiryInfo = (state: RootState) => state.Inquiry.inquiry;
export const InquiryError = (state: RootState) => state.Inquiry.error;
export const InquiryLoading = (state: RootState) => state.Inquiry.loading;
export const InquiryUpdatedTime = (state: RootState) =>
  state.Inquiry.updatedTime;
export default InquirySlice.reducer;
